import React from "react";
import PropTypes from "prop-types";
import { Col as AntCol } from "antd";

export class Col extends React.Component {
  static defaultProps = {
    offset: 0,
    order: 0,
    pull: 0,
    push: 0,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Flex layout style, can be a string or number. */
    flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** The number of cells to offset Col from the left. */
    offset: PropTypes.number,
    /** Raster order, a number. */
    order: PropTypes.number,
    /** The number of cells that the Col should be moved to the left. */
    pull: PropTypes.number,
    /** The number of cells that the Col should be moved to the right. */
    push: PropTypes.number,
    /** Number of raster cells to occupy. A value of 0 corresponds to display: none. */
    span: PropTypes.number,
    /** screens <576px, could be a span value or an object containing other props */
    xs: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    /** screens ≥576px, could be a span value or an object containing other props. */
    sm: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    /** screens ≥768px, could be a span value or an object containing other props. */
    md: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    /** screens ≥992px, could be a span value or an object containing other props. */
    lg: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    /** screens ≥1200px, could be a span value or an object containing other props. */
    xl: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    /** screens ≥1600px, could be a span value or an object containing other props. */
    xxl: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  };

  render() {
    const { className, ...colProps } = this.props;
    if (colProps.span === 0) {
      colProps.style = { ...colProps.style, display: "none" };
      delete colProps.span;
    }

    return <AntCol className={className} {...colProps} />;
  }
}

export default Col;
